<template>
  <v-container fluid>
    <ControlPanelBulkActions :selected.sync="selected" />

    <ControlPanelList :selected.sync="selected" />
  </v-container>
</template>

<script>
import ControlPanelBulkActions from '@/components/apps/control-panel/ControlPanelBulkActions.vue'
import ControlPanelList from '@/components/apps/control-panel/ControlPanelList.vue'
export default {
  name: 'ControlPanel',
  components: {
    ControlPanelBulkActions,
    ControlPanelList,
  },
  data() {
    return { selected: [] }
  },
}
</script>
